import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import back from "../../assets/back.svg";
import { productVersionDetail } from "../../redux/actions/productActions";
import { JSONTree } from "react-json-tree";
import LoadingSpinnerTable from "../../components/utilites/loader";
import useReactRouterBreadcrumbs from "use-react-router-breadcrumbs";

const ProductVersionHistoryView = () => {
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [productVersionDetailData, setProductVersionDetailData] = useState();
  const [productVersionHistoryOldData, setProductVersionHistoryOldData] =
    useState();
  const [productVersionHistoryNewData, setProductVersionHistoryNewData] =
    useState();
  useEffect(() => {
    setLoading(true);
    console.log(params.id);
    dispatch(productVersionDetail(params.id, onSuccess, onError));
  }, []);

  const onSuccess = (data) => {
    setLoading(false);
    console.log(data.data.data);
    setProductVersionDetailData(data.data.data);
    setProductVersionHistoryOldData(data.data.data.old_data);
    setProductVersionHistoryNewData(data.data.data.new_data);
  };

  const onError = (err) => {
    setLoading(false);
    console.log(err);
  };
  const theme = {
    scheme: "monokai",
    author: "wimer hazenberg (http://www.monokai.nl)",
    base00: "#272822",
    base01: "#383830",
    base02: "#49483e",
    base03: "#75715e",
    base04: "#a59f85",
    base05: "#f8f8f2",
    base06: "#f5f4f1",
    base07: "#f9f8f5",
    base08: "#f92672",
    base09: "#464646",
    base0A: "#f4bf75",
    base0B: "#464646",
    base0C: "#a1efe4",
    base0D: "#464646",
    base0E: "#ae81ff",
    base0F: "#cc6633",
    nestedKeyLabel: {
      fontSize: "14px",
    },
    value: {
      fontSize: "14px",
    },
  };

  const data = [
    {
      heading: "Product ID",
      title: productVersionDetailData?.product?.product_id,
    },
    {
      heading: "Company's Product ID",
      title: productVersionDetailData?.product?.company_product_id,
    },
    {
      heading: "Product Name",
      title: productVersionDetailData?.product?.product_name,
    },
    {
      heading: "Division Name",
      title: productVersionDetailData?.product?.vendorDivision?.name,
    },
    {
      heading: "Status",
      title: productVersionDetailData?.product?.status ? (
        <span className="color-green">Active</span>
      ) : (
        <span className="color-danger">Inactive</span>
      ),
    },
    {
      heading: "Updated By",
      title: productVersionDetailData?.updatedBy?.name,
    },
    {
      heading: "Updated At",
      title: moment(productVersionDetailData?.updatedAt).format("DD MMM YYYY"),
    },
  ];

  const routes = [
    { path: "/", breadcrumb: "Admin" },
    { path: "/product", breadcrumb: " / product" },
    {
      path: "/product/version-history-detail/:id",
      breadcrumb: productVersionDetailData?.product?.product_id
        ? ` / ${productVersionDetailData?.product?.product_id} - version history`
        : " / version history",
    },
  ];
  const breadcrumbs = useReactRouterBreadcrumbs(routes, {
    disableDefaults: true,
  });

  return (
    <>
      <div className="products-page">
        <div className="products-main-div">
          <div className="mx-3">
            {breadcrumbs.map(({ match, breadcrumb }) => (
              <NavLink
                key={match.pathname}
                to={match.pathname}
                className="header-route-page fw_400 cursor_pointer"
              >
                <span className="fs_18">{breadcrumb}</span>
              </NavLink>
            ))}
          </div>
          <div className="products-main-list my-2 py-1">
            <div className="search-container d-flex justify-content-between ">
              <div
                className="d-flex align-items-center p-2 ms-3 m-1 mb-2 cursor_pointer"
                onClick={() => navigate(-1)}
              >
                <img src={back} alt="back_btn" />
                <span className="px-2 dark_grey_color fs_16 fn_Nunito fw_600">
                  BACK
                </span>
              </div>
            </div>
            <div style={{ position: "relative" }}>
              {loading == true ? (
                <div className="list-spinner-container">
                  <LoadingSpinnerTable />
                </div>
              ) : (
                <>
                  <div className="pt-3 ps-5 row">
                    {data.map((item, index) => (
                      <div className="mb-2 col-6 col-sm-5 col-md-3 col-xl mx-2">
                        <h5 className="color_b0b3c7 text-nowrap fs_15 fw_500 m-0">
                          {item.heading}
                        </h5>
                        <p className={` fs_16 fn_Nunito text-nowrap fw_600`}>
                          {item.title}
                        </p>
                      </div>
                    ))}
                  </div>
                  <div className=" mx-3 d-none d-xl-block form-sub-details my-3 mb-4">
                    <div className="d-flex justify-content-between">
                      <div className="col-5 mx-4 ">JSON Old Data</div>
                      <div className="col-6">
                        <span className="ms-4 ps-2">JSON New Data</span>
                      </div>
                    </div>
                  </div>
                  <div className="d-xl-flex flex-column flex-md-row justify-content-between col-xl-11 gap-xxl-4 mt-5  mt-xl-0">
                    <div
                      className="col-10 col-xl-6 my-2 mx-auto mx-xl-3 px-xl-2 ms-xl-4 ps-xl-3"
                      style={{ minHeight: "30rem" }}
                    >
                      <div>
                        <h6
                          className="px-3 py-3 my-auto"
                          style={{
                            backgroundColor: "#E7E5FF",
                            borderTopLeftRadius: "10px",
                            borderTopRightRadius: "10px",
                          }}
                        >
                          Old Data
                        </h6>
                        <div className="">
                          <div className="admin_aprvls_vrsn_hstry_data_container  mt-3 pt-3 px-3">
                            <>
                              {productVersionHistoryOldData === null ? (
                                <>Empty data</>
                              ) : (
                                <>
                                  <JSONTree
                                    theme={theme}
                                    data={productVersionHistoryOldData}
                                  />
                                  ;
                                </>
                              )}
                            </>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="col-10 col-xl-6 my-2 mx-xl-3 mx-auto"
                      style={{ minHeight: "30rem" }}
                    >
                      <div>
                        <h6
                          className="px-3 py-3 my-auto"
                          style={{
                            backgroundColor: "#E7E5FF",
                            borderTopLeftRadius: "10px",
                            borderTopRightRadius: "10px",
                          }}
                        >
                          New Data
                        </h6>
                        <div className="">
                          <div className="admin_aprvls_vrsn_hstry_data_container  mt-3 pt-3 px-3">
                            <>
                              {productVersionHistoryNewData === null ? (
                                <>Empty data</>
                              ) : (
                                <>
                                  <JSONTree
                                    theme={theme}
                                    data={productVersionHistoryNewData}
                                  />
                                  ;
                                </>
                              )}
                            </>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductVersionHistoryView;
